<template>
  <div class="wrapper">
    <div class="leftBox">
      <!-- type=0为整车 -->
      <Car
        v-if="itemData.detail && itemData.detail.type === 0"
        :key="carOutList.length + carInUrl.length"
        :outList="carOutList"
        :inUrlList="carInUrl"
      ></Car>
      <!-- <img v-else :src="itemData.url" alt="" srcset="" /> -->
      <el-image v-else style="width: 350px; height: 350px ;margin-right:35px" :src="itemData.url" fit="contain"></el-image>
    </div>
    <div class="rightBox">
      <div class="nameAndPriceBox">
        <div class="contentleftBox">
          <div class="maintitle">{{ itemData.name }}</div>
          <div class="subTitle">{{ itemData.subName }}</div>
        </div>
        <!-- 如果是搭配商品的时候，这里的subTitle是为空 -->
        <div class="contentrightBox" :class="{ subCommidity: itemData.subName && itemData.subName != '' }">
          <!-- 商品类型 0:整车,1:备件,2:精品,3:卡券,4:维保 -->
          <div class="mainPrice">
            <!-- 整车订金 或 精品价格 -->
            <span>{{ itemData.detail && itemData.detail.type === 0 ? '订金' : '价格' }}</span
            ><span class="highLight">￥{{ itemData.price | currency('', 2) }}</span>
          </div>
          <!-- 整车显示价格 -->
          <div class="subPrice" v-if="itemData.detail && itemData.detail.type === 0">
            <span>价格</span>￥{{ itemData.nativePrice | currency('', 2) }}
          </div>
          <!-- <div class="mainPrice"><span>价格</span>9.98万</div> -->
        </div>
      </div>
      <div class="configBox ">
        <Sku :skuData="oneCommodityData" :callback="getDataSKU"> </Sku>
        <div
          class="configItem"
          :class="{ dealerRow: item.label === '经销商' }"
          v-for="(item, index) in itemData.config"
          :key="index"
        >
          <div class="label" v-if="item.num || item.label === '经销商'">{{ item.label }}</div>
          <!-- 多选样式 -->
          <!-- <div class="optionBox" v-if="item.options && item.options.length > 0">
            <div
              class="optionItem"
              :class="{ checked: item.value === item2.attrVal }"
              v-for="(item2, index2) in item.options"
              :key="index2"
              @click="checkOneAttr(item, item2)"
            >
              {{ item2.attrVal }}
            </div>
          </div> -->
          <!-- 数量 -->
          <div class="optionBox inputNumber" v-if="item.num">
            <el-input-number
              style="height:40px;width: 155px;"
              v-model="item.num"
              @input="updateTotalMoney"
              :min="1"
              :max="itemData.limitNum"
              label="描述文字"
            />
            <div
              class="btnStyl"
              @click="checkCommodity(itemData)"
              v-if="itemData.sign === 'sub' && itemData.mode === 0"
              :class="{ checkBtn: !itemData.checked, cancelBtn: itemData.checked }"
            >
              {{ !itemData.checked ? '选择' : '取消选择' }}
            </div>
          </div>
          <!-- 经销商 -->
          <div
            @click="dealer = true"
            v-if="item.label === '经销商' && itemData.detail && itemData.detail.type === 0"
            class="distributor"
            :class="{ txtColor: dealerName }"
          >
            {{ dealerName ? dealerName : '选择经销商' }}
          </div>
        </div>
      </div>
    </div>
    <!-- 经销商选择页面 -->
    <!-- :show  控制弹窗弹出
    :sellOf   商品编码
    :isNewretail 是否是新零售
    dealerCodes 经销商编号
    @dealerData  经销商数据 -->
    <!-- type=0为整车 -->
    <distributor
      ref="distributor"
      :codes="dealerCodes"
      :isNewretail="isNewretail"
      :sellOf="sellOf"
      :show.sync="dealer"
      @dealerData="dealerData"
    ></distributor>
  </div>
</template>

<script>
import distributor from '../../../components/business/mall/distributor.vue'
import Sku from '../../../components/common/sku-new'
import Car from './car'
import getData from '@/api/details'
export default {
  components: { Sku, Car, distributor },
  props: {
    // {
    //       name: '主商品名称',
    //       price: '9.98万',
    //       deposit: '99.00',
    //       checked: true,
    //       url: 'https://ss2.bdstatic.com/70cFvnSh_Q1YnxGkpoWK1HF6hhy/it/u=3130125737,4291579555&fm=26&gp=0.jpg',
    //       config: [
    //         {
    //           label: '动力',
    //           value: '',
    //           options: ['1.5TCL-6MT', '1.6T-5MT']
    //         },
    //         {
    //           label: '车型',
    //           value: '',
    //           options: ['五座版精英型1', '五座版精英型2', '五座版精英型3', '五座版精英型4']
    //         },
    //         {
    //           label: '经销商'
    //         },
    //         {
    //           label: '数量',
    //           num: 1,
    //           status: true
    //         }
    //       ]
    //     },
    // 当前商品的详情
    itemData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // 商品列表
    commodityList: {
      type: Array,
      default: () => {
        return []
      }
    },
    // 默认经销商id
    defaultDealerId: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      dealerName: '',
      dealer: false, // 弹框展示标识
      isNewretail: '', // 是否是新零售
      dealerCodes: [], // 经销商编号
      sellOf: '', // 商品编码
      skuData: {},
      oneCommodityData: {},
      carOutList: [],
      carInUrl: []
    }
  },
  computed: {},
  created() {},
  mounted() {
    this.$nextTick(() => {
      this.oneCommodityData = JSON.parse(JSON.stringify(this.itemData))
      // 获取经销商code
      const item = this.oneCommodityData.detail
      if (item.activityItemInfoDto && !item.activityItemInfoDto.forAllDealers) {
        item.activityItemInfoDto.activityDealerDto &&
          JSON.parse(item.activityItemInfoDto.activityDealerDto.dealerInfo) &&
          JSON.parse(item.activityItemInfoDto.activityDealerDto.dealerInfo).map((res) => {
            this.dealerCodes.push(res.code)
          })
      }
      // 商品编码
      this.sellOf = item.itemCode
      // 获得是否是新零售
      this.isNewretail = item.extra && item.extra.newRetail // 新零售
      //  获取整车外观内设数据
      if (this.itemData.detail && this.itemData.detail.type === 0) {
        this.getAllCarImg(item.outerId)
      }
      //  整车:type=0
      if (this.itemData.detail && this.itemData.detail.type === 0) {
        this.$refs.distributor.getActicityDealerList(this.defaultDealerId)
      }
    })
  },
  methods: {
    getAllCarImg(outerId) {
      // 获取360图片
      getData.getAllCarImg({ itemId: outerId }).then((res) => {
        const { data = [], status } = res
        if (Number(status) === 200) {
          this.carOutList = data.filter((item) => Number(item.type) === 0)
          this.carInUrl = data.filter((item) => Number(item.type) === 1)
        }
      })
    },
    /**
     * 选择商品
     * obj-商品实体
     */
    checkCommodity(obj) {
      //  <!-- mode 1-固定 0-自由 -->
      if (obj.mode === 1) {
        this.$feedback('固定搭配套餐中的搭配商品都是必选的')
        return
      } else {
      }
      // 如果是主商品，是不能取消的
      if (obj.sign === 'main') {
        this.$feedback('主商品是必选的')
      } else {
        // 取消选择操作,需要判断当前选中的商品有几个，如果只有1个，是不能取消删除的
        if (obj.checked) {
          let n = 0
          this.commodityList.forEach((obj) => {
            if (obj.sign === 'sub' && obj.checked) {
              n++
            }
          })
          if (n > 1) {
            obj.checked = !obj.checked
          } else {
            this.$feedback('搭配商品至少选择一个')
          }
        } else {
          obj.checked = !obj.checked
        }
      }
      this.$emit('computeMoney')
    },
    /**
     * 触发更新价格
     */
    updateTotalMoney() {
      this.$emit('computeMoney')
    },
    /**
     * sku回调
     */
    getDataSKU(data) {
      // 设置价格
      // 活动价
      this.itemData.price = data.price
      // 原价
      this.itemData.nativePrice = data.nativePrice ? data.nativePrice : data.price
      // 商品图片
      this.itemData.url = data.image || data.skuImage
      this.itemData.skuId = data.skuId

      this.$emit('computeMoney')
    },
    /**
     * @descripttion: 选择某一个属性的回调
     * @Author: lujing
     * @Date: 2021-04-20 11:52:38
     * @param parent表示当前的销售属性-如颜色
     * @param child表示当前具体的销售属性的某个值-如黄色
     * @return {void}
     */
    checkOneAttr(parent, child) {
      parent.value = child.attrVal
    },

    /**
     * 返回选择经销商信息
     */
    dealerData(data) {
      this.dealerName = data.name
      this.dealerId = data.id
      this.dealerCode = data.orgCode
      this.$emit('getdealerId', this.dealerId)
    }
  }
}
</script>

<style scoped lang="scss">
.wrapper {
  border-bottom: 1px solid #d4d4d4;
  padding-bottom: 25px;
  margin-bottom: 25px;
  display: flex;
  .leftBox,
  .rightBox {
    padding-left: 50px;

    .nameAndPriceBox {
      display: flex;
      justify-content: space-between;

      .contentleftBox {
        .maintitle {
          font-size: 20px;
          font-weight: bold;
          color: #333;
          margin-bottom: 20px;
        }
        .subTitle {
          font-size: 14px;
          color: #999;
        }
      }
      .contentrightBox {
        .mainPrice {
          color: #777;
          font-size: 14px;
          display: flex;
          align-items: flex-end;
          justify-content: flex-end;
          margin-bottom: 20px;
          .highLight {
            color: #c6001f;
            font-size: 20px;
            margin-left: 3px;
            font-weight: bold;
          }
        }
        .subPrice {
          font-size: 14px;
          color: #777;
        }
      }
      .subCommidity {
        margin-bottom: 30px;
      }
    }
    .configBox {
      ::v-deep .el-input-number__decrease,
      ::v-deep .el-input-number__increase {
        top: 2px !important;

      }
      .configItem {
        display: flex;
        // margin-bottom: 15px;
        // margin-bottom: 15px;
        &.dealerRow {
          margin-bottom: 30px;
        }
        .label {
          color: #777;
          font-size: 15px;
          height: 40px;
          line-height: 40px;
          display: inline-block;
          flex: 0 0 80px;
        }
        .optionBox {
          font-size: 15px;
          color: #333;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          .optionItem {
            height: 40px;
            line-height: 40px;
            text-align: center;
            border: 1px solid #e2e2e2;
            width: 150px;
            margin: 0 10px 10px;
            cursor: pointer;

            &.checked {
              border: 1px solid #c6001f;
              position: relative;
              &::after {
                content: '';
                display: inline-block;
                position: absolute;
                right: 0;
                bottom: 0;
                width: 16px;
                height: 16px;
                background: url('../../../assets/icons/other/checkConfig.png') center/100% 100%;
              }
            }
          }
          .btnStyl {
            width: 120px;
            height: 35px;
            line-height: 35px;
            text-align: center;
            cursor: pointer;
            // 选择按钮
            &.checkBtn {
              color: white;
              background: #c6001f;
            }
            // 取消按钮
            &.cancelBtn {
              border: 1px solid #c6001f;
              background: #c6001f11;
              color: #c6001f;
            }
          }
        }
        .inputNumber {
          margin-left: 2px;
          width: 100%;
          position: relative;
        }
        .distributor {
          height: 40px;
          line-height: 40px;
          border: 1px solid #e2e2e2;
          margin-left: 2px;
          padding-left: 20px;
          font-size: 14px;
          color: #ccc;
          width: 272px;
          padding: 0 15px;
          line-height: 36px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          box-sizing: border-box;
          background: url('../../../assets/images/seller/search.png') 237px center no-repeat;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          &.txtColor {
            color: #333;
          }
          &.check {
            color: #333;
          }
        }
      }
    }
  }
  .leftBox {
    img {
      height: 350px;
      width: 350px;
    }
  }
  .rightBox {
    padding-top: 10px;
    flex: 1;
  }
}
</style>
